if (!customElements.get("sticky-atc-bar")) {
	customElements.define(
		"sticky-atc-bar",
		class StickyAtcBar extends HTMLElement {
			constructor() {
				super();
				document.body.classList.add("sticky-atc-bar-enabled");

				this.selectors = {
					variantIdSelect: '[name="id"]',
				};
			}

			get sectionId() {
				return this.dataset.originalSection || this.dataset.section;
			}

			connectedCallback() {
				this.productFormActions = document.querySelector(
					".product-form"
				);
				this.container = this.closest(".sticky-atc-bar");
				this.mainProduct = document.querySelector(
					"product-info[id^='MainProduct']"
				);
				this.hasPackOptions = this.dataset.hasPackOptions === "true";
				this.variantData = this.getVariantData();
				this.select = this.querySelector("select");

				this.init();

				if (this.hasPackOptions) {
					this.initStickyPackControls();
					this.initPackSync();
					this.initPackSubmit();
				}

				if (this.select) {
					this.select.addEventListener("change", () => {
						const mainVariantPicker =
							this.mainProduct.querySelector("variant-picker");
						const selectedVariantId = this.querySelector(
							this.selectors.variantIdSelect
						).value;
						this.currentVariant = this.variantData.find(
							(variant) => variant.id === Number(selectedVariantId)
						);

						if (mainVariantPicker) {
							Array.from(
								mainVariantPicker.querySelectorAll(
									"select, .variant-picker__option-values"
								),
								(element, index) => {
									const variantOptionVal = this.currentVariant.options[index];
									switch (element.tagName) {
										case "SELECT":
											element.value = variantOptionVal;
											break;
										case "DIV":
											Array.from(element.querySelectorAll("input")).forEach(
												(radio) => {
													if (radio.value === variantOptionVal) {
														radio.checked = true;
													}
												}
											);
											break;
									}
								}
							);
							mainVariantPicker.dispatchEvent(new Event("change"));
						}

						this.updatePrice();
						this.updateButton(true, "", false);
						if (!this.currentVariant) {
							this.updateButton(true, "", true);
						} else {
							this.updateButton(
								!this.currentVariant.available,
								window.FoxThemeStrings.soldOut
							);
						}
					});
				}
			}

			getVariantData() {
				this.variantData =
					this.variantData ||
					JSON.parse(
						this.container.querySelector('[type="application/json"]')
							.textContent
					);
				return this.variantData;
			}

			init() {
				if (!this.productFormActions) {
					this.container.classList.add("sticky-atc-bar--show");
					return;
				}
				this.productId = this.dataset.productId;
				const isMobile = window.matchMedia("(max-width: 639px)");

				try {
					// Chrome & Firefox
					isMobile.addEventListener("change", this.checkDevice.bind(this));
				} catch (err) {
					try {
						// Safari
						isMobile.addListener(this.checkDevice.bind(this));
					} catch (e2) {
						console.error(e2);
					}
				}

				// Initial check
				this.checkDevice(isMobile);

				const headerHeightCss = getComputedStyle(document.documentElement)
					.getPropertyValue("--header-height")
					.trim();
				const headerHeight = headerHeightCss ? parseFloat(headerHeightCss) : 80;

				const rootMargin = `-${headerHeight}px 0px 0px 0px`;

				this.observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							const reachedHeaderZone = entry.boundingClientRect.top < headerHeight;
							const notFullyVisible = entry.intersectionRatio < 1;

							this.container.classList.toggle(
								"sticky-atc-bar--show",
								reachedHeaderZone && notFullyVisible
							);
						});
					},
					{ threshold: 1, rootMargin }
				);
				this.setObserveTarget();
				this.syncWithMainProductForm();
			}

			setObserveTarget() {
				this.observer.observe(this.productFormActions);
				this.observeTarget = this.productFormActions;
			}

			checkDevice(e) {
				setTimeout(() => {
					const sectionHeight = this.clientHeight + "px";
					document.documentElement.style.setProperty(
						"--f-sticky-atc-bar-height",
						sectionHeight
					);
				}, 100);
			}

			updateButton(disable = true, text, modifyClass = true) {
				const productForm = document.getElementById(
					"product-form-sticky-atc-bar"
				);
				if (!productForm) return;
				const addButton = productForm.querySelector('[name="add"]');
				const addButtonText = productForm.querySelector(
					'[name="add"] > span:not(.f-icon)'
				);

				if (!addButton) return;

				if (disable) {
					addButton.setAttribute("disabled", "disabled");
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute("disabled");
					addButtonText.textContent = window.FoxThemeStrings.addToCart;
				}
			}

			updatePrice() {
				const classes = {
					onSale: "price--on-sale",
					soldOut: "price--sold-out",
				};
				const selectors = {
					priceWrapper: ".price",
					salePrice: ".price-item--sale",
					compareAtPrice: [".price-item--regular"],
					unitPrice: ".price__unit",
					saleBadge: ".price__badge-sale",
					saleAmount: "[data-sale-value]",
				};
				const money_format = window.themeSettings.money_format;
				const { priceWrapper, salePrice, unitPrice, compareAtPrice } =
					queryDomNodes(selectors, this);

				const { compare_at_price, price, unit_price_measurement } =
					this.currentVariant;

				const onSale = compare_at_price && compare_at_price > price;
				const soldOut = !this.currentVariant.available;

				if (onSale) {
					priceWrapper.classList.add(classes.onSale);
				} else {
					priceWrapper.classList.remove(classes.onSale);
				}

				if (soldOut) {
					priceWrapper.classList.add(classes.soldOut);
				} else {
					priceWrapper.classList.remove(classes.soldOut);
				}

				if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
				if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

				if (
					compareAtPrice &&
					compareAtPrice.length &&
					compare_at_price > price
				) {
					compareAtPrice.forEach(
						(item) =>
							(item.innerHTML = formatMoney(compare_at_price, money_format))
					);
				} else {
					compareAtPrice.forEach(
						(item) => (item.innerHTML = formatMoney(price, money_format))
					);
				}

				if (unit_price_measurement && unitPrice) {
					unitPrice.classList.remove("hidden");
					const unitPriceContent = `<span>${formatMoney(
						this.currentVariant.unit_price,
						money_format
					)}</span>/<span data-unit-price-base-unit>${getBaseUnit(
						this.currentVariant
					)}</span>`;
					unitPrice.innerHTML = unitPriceContent;
				} else {
					unitPrice.classList.add("hidden");
				}
			}

			syncWithMainProductForm() {
				const variantInput = this.querySelector('[name="id"]');

				window.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
					const isMainProduct =
						evt.data.sectionId === this.mainProduct.dataset.section;

					if (!isMainProduct) return;

					this.currentVariant = evt.data.variant;

					if (!this.currentVariant) {
						this.container.classList.add("hidden");
						return;
					}

					this.container.classList.remove("hidden");
					variantInput.value = this.currentVariant.id;

					this.updatePrice();

					this.updateButton(
						!this.currentVariant.available,
						window.FoxThemeStrings.soldOut
					);

					if (this.hasPackOptions) {
						const selectedPack = this.mainProduct.querySelector(
							'[data-pack-quantity]:checked'
						);

						if (selectedPack) {
							this.updatePackState({
								quantity: Number(selectedPack.dataset.packQuantity),
								price: selectedPack.dataset.packPriceFormatted,
							});
						}

						this.syncStickyPackControls();
					}
				});
			}

			initStickyPackControls() {
				this.stickyPackButtons = this.querySelectorAll("[data-sticky-pack]");
				this.stickyBagButtons = this.querySelectorAll("[data-sticky-bag]");
				this.stickyPackSizes = this.querySelectorAll("[data-sticky-pack-size]");

				this.stickyPackButtons.forEach((button) => {
					button.addEventListener("click", () => {
						const quantity = Number(button.dataset.packQuantity);

						const mainPackInput = this.mainProduct.querySelector(
							`[data-pack-quantity="${quantity}"]`
						);

						if (!mainPackInput) return;

						mainPackInput.checked = true;
						mainPackInput.dispatchEvent(
							new Event("change", { bubbles: true })
						);
					});
				});

				this.stickyBagButtons.forEach((button) => {
					button.addEventListener("click", () => {
						const bagNumber = Number(button.dataset.stickyBag);
						const variantId = Number(button.dataset.variantId);

						if (bagNumber === 1) {
							this.updateMainBagOne(variantId);
							return;
						}

						const mainSizeInput = this.mainProduct.querySelector(
							`[data-pack-size="${bagNumber}"] [data-pack-variant][value="${variantId}"]`
						);

						if (!mainSizeInput) return;

						mainSizeInput.checked = true;
						mainSizeInput.dispatchEvent(
							new Event("change", { bubbles: true })
						);
					});
				});
			}

			updateMainBagOne(variantId) {
				const variant = this.variantData.find(
					(variant) => variant.id === variantId
				);

				if (!variant) return;

				this.querySelectorAll('[data-sticky-bag="1"]').forEach((button) => {
					button.classList.toggle(
						"is-active",
						Number(button.dataset.variantId) === variantId
					);
				});

				const mainVariantPicker =
					this.mainProduct.querySelector("variant-selects");

				if (!mainVariantPicker) return;

				const optionValue = variant.options[0];

				const input = Array.from(
					mainVariantPicker.querySelectorAll('input[type="radio"]')
				).find((radio) => radio.value === optionValue);

				if (!input) return;

				input.click();
			}

			updateStickySizeVisibility(quantity) {
				this.stickyPackSizes.forEach((picker) => {
					const bagNumber = Number(picker.dataset.stickyPackSize);

					picker.classList.toggle(
						"hidden",
						bagNumber > quantity
					);
				});
			}

			syncStickyPackControls() {
				const selectedPack = this.mainProduct.querySelector(
					"[data-pack-quantity]:checked"
				);

				if (!selectedPack) return;

				const quantity = Number(
					selectedPack.dataset.packQuantity
				);

				this.stickyPackButtons.forEach((button) => {
					button.classList.toggle(
						"is-active",
						Number(button.dataset.packQuantity) === quantity
					);
				});

				this.updateStickySizeVisibility(quantity);

				const mainVariantInput = this.mainProduct.querySelector(
					'product-form input[name="id"]'
				);

				if (mainVariantInput) {
					this.querySelectorAll('[data-sticky-bag="1"]').forEach((button) => {
						button.classList.toggle(
							"is-active",
							Number(button.dataset.variantId) === Number(mainVariantInput.value)
						);
					});
				}

				for (let bagNumber = 2; bagNumber <= quantity; bagNumber++) {
					const selectedVariant = this.mainProduct.querySelector(
						`[data-pack-size="${bagNumber}"] [data-pack-variant]:checked`
					);

					if (!selectedVariant) continue;

					this.querySelectorAll(
						`[data-sticky-bag="${bagNumber}"]`
					).forEach((button) => {
						button.classList.toggle(
							"is-active",
							Number(button.dataset.variantId) === Number(selectedVariant.value)
						);
					});
				}
			}

			initPackSync() {
				const selectedPack = this.mainProduct.querySelector(
					"[data-pack-quantity]:checked"
				);

				if (selectedPack) {
					this.updatePackState({
						quantity: Number(selectedPack.dataset.packQuantity),
						price: selectedPack.dataset.packPriceFormatted,
					});
				}

				this.syncStickyPackControls();

				this.mainProduct.addEventListener("pack:change", (event) => {
					this.updatePackState(event.detail);
					this.syncStickyPackControls();
				});
			}

			updatePackState({ quantity, price }) {
				this.updateStickyPackPrice(price);
				this.updateStickyPackButton(quantity, price);
			}

			updateStickyPackPrice(price) {
				if (!price) return;

				const priceElement =
					this.querySelector(".price--on-sale .price-item--sale") ||
					this.querySelector(".price__regular .price-item--regular");

				if (!priceElement) return;

				priceElement.textContent = price;
			}

			updateStickyPackButton(quantity, price) {
				const addButton = this.querySelector('[name="add"]');
				const addButtonText = addButton?.querySelector(
					"span:not(.f-icon)"
				);

				if (!addButtonText) return;

				const template =
					quantity === 1
						? window.variantStrings.pack_add
						: window.variantStrings.packs_add;

				addButtonText.textContent = template
					.replace("[quantity]", quantity)
					.replace("[price]", price);
			}

			initPackSubmit() {
				const addButton = this.querySelector('[name="add"]');

				if (!addButton) return;

				addButton.addEventListener("click", () => {
					const mainForm = this.mainProduct.querySelector(
						'product-form form[data-type="add-to-cart-form"]'
					);

					if (!mainForm) return;

					mainForm.requestSubmit();
				});
			}
		}
	);
}
